import YouTubePlayer from 'youtube-player';



export default class VideoPlayer {

    VIDEO_HOSTED = "hosted"
    VIDEO_EXTERNAL = "external"

    constructor(video) {
        this.el = {}

        this.el.video = video
        this.el.DOM = this.el.video.closest(".c-video");
        this.el.URL = this.el.DOM.dataset.videoUrl

        this.el.wrapperVideo = this.el.DOM.querySelector('.c-video__video')
        this.el.originDOM = this.el.wrapperVideo.innerHTML;
        this.el.type = this.getVideoType();
        this.el.player = null
        this.el.videoIsCreate = false
    }

    destroy() {
        this.el.wrapperVideo.innerHTML = this.el.originDOM
        this.el.DOM.classList.remove('c-video--up')
        this.videoIsCreate = false
    }


    playVideo() {
        if (!this.videoIsCreate) {
            console.log(this.el.t)
            if (this.el.type !== this.VIDEO_EXTERNAL) {
                this.isHosted();
            }
            else {
                this.isExternal()
            }
        }
        this.el.DOM.classList.add("c-video--up")
    }

    createElementVideoFullScreen() {
        let player = document.querySelector(".c-video__fullscreen");

        if (player) {
            document.querySelector(".c-video__fullscreen").innerHTML = ''
        }
        else {
            this.player = document.createElement("div")
            this.player.classList.add("c-video__fullscreen");
            document.body.append(this.player)
        }
    }

    getVideoType() {
        return this.el.DOM.dataset.videoType === this.VIDEO_EXTERNAL ? this.VIDEO_EXTERNAL : this.VIDEO_HOSTED
    }

    isHosted() {

        this.player = document.createElement('video')
        this.player.autoplay = true
        this.player.controls = true
        this.player.id = "myVideo"
        this.player.setAttribute('height', "auto")
        this.player.setAttribute('width', "100%")
        this.player.style.zIndex = "1"

        let source = document.createElement('source')
        source.src = this.el.URL
        source.type = "video/mp4"

        this.player.appendChild(source)
        this.el.wrapperVideo.innerHTML = ''
        this.el.wrapperVideo.appendChild(this.player)

        this.videoIsCreate = true
    }

    isExternal() {

        const id = this.getIdFromYoutubeURL(this.el.URL)
        this.el.wrapperVideo.innerHTML = ''
        let wrapper = document.createElement('div')
        this.el.wrapperVideo.appendChild(wrapper)

        window.YT === undefined ? this.displayDisclaimerCookie() : this.createYoutubePlayer(wrapper, id)

    }

    displayDisclaimerCookie() {
        this.el.wrapperVideo.innerHTML = `<div class="c-video__nocookie">Veuillez accepter les cookies pour voir la vidéo</div>`
    }


    createYoutubePlayer(wrapper, id) {

        this.player = new YT.Player(wrapper, {
            wmode: 'transparent',
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                wmode: 'transparent',
                showinfo: 0,
                autohide: 1,
            },
            videoId: id,
            events: {
                'onReady': onPlayerReady
            }
        });

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        this.videoIsCreate = true




    }

    // https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
    getIdFromYoutubeURL(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

    stop() {
        if (this.videoIsCreate) {
            if (this.el.type === this.VIDEO_HOSTED) {
                this.player.pause()
            } else {
                this.player.stopVideo()
            }
        }
    }
}